var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignAnimalEu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Animal_x5F_EU",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M89.998,88H6.002c-3.084,0-5.006-3.346-3.452-6.011L44.548,9.983c1.542-2.644,5.362-2.644,6.904,0 L93.45,81.989C95.004,84.654,93.082,88,89.998,88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M48,8c-1.34,0-2.681,0.661-3.452,1.983L2.55,81.989C0.996,84.654,2.918,88,6.002,88h83.995 c3.084,0,5.006-3.346,3.452-6.011L51.452,9.983C50.681,8.661,49.34,8,48,8L48,8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B33229"
    },
    d: "M48,23.868L79.573,78H16.427L48,23.868 M48,9.959c-0.671,0-1.342,0.331-1.728,0.992L4.254,82.992 C3.477,84.326,4.438,86,5.982,86h84.036c1.544,0,2.505-1.674,1.728-3.008L49.728,10.951C49.342,10.289,48.671,9.959,48,9.959 L48,9.959z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.836,66.497l-1.226-2.025c-0.917,0.444-2.022,0.06-2.467-0.856c-0.002-0.003-0.004-0.004-0.004-0.008l-0.737-1.531 l6.1,1.657l0.203-0.745c3.561,1.462,7.372,2.214,11.223,2.221c0.704,2.234,2.433,4,4.654,4.76l2.097,0.718 c1.143,0.388,2.138,1.121,2.852,2.091l1.549,2.105C68.805,75.877,69.828,76.616,71,77l-0.371-2.224 c-0.613,0.077-1.209-0.232-1.495-0.778l-2.385-4.553l-1.488-1.047c-1.818-0.942-2.754-3.003-2.263-4.985l0.197-0.8 c0.157-0.634-0.122-1.294-0.688-1.622l-1.832-1.072c-0.302-0.175-0.623-0.316-0.958-0.417l-10.016-3.022 c-1.913-0.576-3.405-2.076-3.965-3.992l-1.348-4.597c0.979,0,1.896-0.485,2.448-1.29l-3-0.183l3.76-2.143 c1.092-0.622,1.791-1.753,1.859-3.003c0.007-0.143-0.103-0.262-0.246-0.271c-0.122-0.006-0.234,0.075-0.263,0.194l-0.048,0.178 c-0.211,0.821-0.766,1.511-1.524,1.895l-0.213,0.109c-0.11,0.056-0.242,0.01-0.298-0.097c-0.025-0.047-0.031-0.101-0.018-0.152 l0.35-1.449c0.027-0.118-0.046-0.237-0.166-0.266c-0.1-0.025-0.203,0.024-0.248,0.115l-1.205,2.409 c-0.105,0.212-0.277,0.384-0.491,0.491l-0.507,0.258c-0.11,0.056-0.244,0.013-0.3-0.097c-0.023-0.045-0.031-0.099-0.016-0.151 l0.53-2.207c0.029-0.119-0.044-0.239-0.164-0.266c-0.1-0.025-0.205,0.023-0.251,0.115l-1.314,2.632 c-0.317,0.634-0.882,1.111-1.561,1.317l-4.315,1.309v1.288l3.88,1.108l1.147,8.682c0.114,0.884,0.495,1.707,1.091,2.372 l-5.662-0.916c-0.3-0.045-0.586,0.157-0.635,0.458c-0.019,0.123,0.004,0.246,0.062,0.357l2.052,3.72 c0.58,1.049,1.637,1.754,2.834,1.887L43.836,66.497z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignAnimalEu);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_animal_eu.9496fc38e02927292aae61d6ac0b9b4e.svg";
export { ForwardRef as ReactComponent };